import type { Rule } from "../../../hooks/react-query/backOffice/pricingAndRating/useRules";

// Mock data for rule types
export const mockRuleTypes = [
  {
    id: 1,
    code: "ITEM_1375",
    displayName: "ITEM_1375 - Linear Foot Rule",
    description: "Linear Foot Rule",
  },
  {
    id: 2,
    code: "ITEM_1360",
    displayName: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Minimum Charge Cubic Capacity and Density",
  },
  {
    id: 3,
    code: "ITEM_1400",
    displayName:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Residential Delivery - Auto Application of Liftgate Rule",
  },
];

export const mockRateClasses = [
  {
    id: 77,
    code: "50",
    displayName: "Class 50",
    description: "Tariff Class 50",
  },
  {
    id: 76,
    code: "55",
    displayName: "Class 55",
    description: "Tariff Class 55",
  },
  {
    id: 75,
    code: "60",
    displayName: "Class 60",
    description: "Tariff Class 60",
  },
  {
    id: 74,
    code: "65",
    displayName: "Class 65",
    description: "Tariff Class 65",
  },
  {
    id: 73,
    code: "70",
    displayName: "Class 70",
    description: "Tariff Class 70",
  },
  {
    id: 72,
    code: "77.5",
    displayName: "Class 77.5",
    description: "Tariff Class 77.5",
  },
  {
    id: 71,
    code: "85",
    displayName: "Class 85",
    description: "Tariff Class 85",
  },
  {
    id: 70,
    code: "92.5",
    displayName: "Class 92.5",
    description: "Tariff Class 92.5",
  },
  {
    id: 69,
    code: "100",
    displayName: "Class 100",
    description: "Tariff Class 100",
  },
  {
    id: 68,
    code: "110",
    displayName: "Class 110",
    description: "Tariff Class 110",
  },
  {
    id: 67,
    code: "125",
    displayName: "Class 125",
    description: "Tariff Class 125",
  },
];

// Mock data for applied accessorial dropdown options
export const appliedAccessorialOptions = [
  { value: "LIFTGATE_DELIVERY", label: "Liftgate Delivery" },
  { value: "INSIDE_DELIVERY", label: "Inside Delivery" },
  { value: "RESIDENTIAL_DELIVERY", label: "Residential Delivery" },
];

// Generate comprehensive mock rules based on API contract
export const mockRules: Rule[] = [
  {
    id: 123,
    name: "Standard Minimum",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Standard default rate for all shipments",
    effectiveDate: "11/05/2025",
    expirationDate: "11/05/2026",
    version: 5,
    status: "Active",
    createdDate: "10/15/2025",
    createdBy: "John Doe",
    modifiedDate: "11/01/2025",
    modifiedBy: "Jane Smith",
  },
  {
    id: 124,
    name: "Standard Linear",
    ruleType: "ITEM_1375",
    ruleTypeDisplay: "ITEM_1375 - Linear Foot Rule",
    description: "Standard linear rate for freight",
    effectiveDate: "11/05/2025",
    expirationDate: "11/05/2026",
    version: 5,
    status: "Active",
    createdDate: "10/15/2025",
    createdBy: "John Doe",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 125,
    name: "Express Delivery Rule",
    ruleType: "ITEM_1375",
    ruleTypeDisplay: "ITEM_1375 - Linear Foot Rule",
    description: "Premium express delivery charges",
    effectiveDate: "10/01/2025",
    expirationDate: "10/01/2026",
    version: 3,
    status: "Active",
    createdDate: "09/15/2025",
    createdBy: "Alice Johnson",
    modifiedDate: "10/05/2025",
    modifiedBy: "Bob Wilson",
  },
  {
    id: 126,
    name: "Holiday Surcharge",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Additional charges during holiday season",
    effectiveDate: "12/01/2025",
    expirationDate: "01/15/2026",
    version: 1,
    status: "Draft",
    createdDate: "11/20/2025",
    createdBy: "Carol Martinez",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 127,
    name: "Hazmat Handling",
    ruleType: "ITEM_1400",
    ruleTypeDisplay:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Special handling fee for hazardous materials",
    effectiveDate: "01/01/2025",
    expirationDate: "12/31/2026",
    version: 8,
    status: "Active",
    createdDate: "12/01/2024",
    createdBy: "David Lee",
    modifiedDate: "06/15/2025",
    modifiedBy: "Eve Chen",
  },
  {
    id: 128,
    name: "Weekend Pickup",
    ruleType: "ITEM_1400",
    ruleTypeDisplay:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Weekend and after-hours pickup charges",
    effectiveDate: "09/01/2025",
    expirationDate: "09/01/2026",
    version: 2,
    status: "Inactive",
    createdDate: "08/10/2025",
    createdBy: "Frank Brown",
    modifiedDate: "08/25/2025",
    modifiedBy: "Grace Taylor",
  },
  {
    id: 129,
    name: "Residential Delivery",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Additional fee for residential address deliveries",
    effectiveDate: "07/01/2025",
    expirationDate: "07/01/2026",
    version: 4,
    status: "Active",
    createdDate: "06/01/2025",
    createdBy: "Henry White",
    modifiedDate: "06/20/2025",
    modifiedBy: "Iris Green",
  },
  {
    id: 130,
    name: "Liftgate Service",
    ruleType: "ITEM_1400",
    ruleTypeDisplay:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Charge for liftgate equipment use",
    effectiveDate: "08/01/2025",
    expirationDate: "08/01/2026",
    version: 6,
    status: "Active",
    createdDate: "07/10/2025",
    createdBy: "Jack Miller",
    modifiedDate: "07/25/2025",
    modifiedBy: "Karen Davis",
  },
  {
    id: 131,
    name: "Inside Delivery",
    ruleType: "ITEM_1400",
    ruleTypeDisplay:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Charge for delivery inside premises",
    effectiveDate: "06/01/2025",
    expirationDate: "06/01/2026",
    version: 3,
    status: "Draft",
    createdDate: "05/15/2025",
    createdBy: "Laura Anderson",
    modifiedDate: "05/28/2025",
    modifiedBy: "Mike Thomas",
  },
  {
    id: 132,
    name: "Fuel Adjustment",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Weekly fuel price adjustment calculation",
    effectiveDate: "01/01/2025",
    expirationDate: null,
    version: 12,
    status: "Active",
    createdDate: "12/15/2024",
    createdBy: "Nancy Jackson",
    modifiedDate: "10/01/2025",
    modifiedBy: "Oscar Martin",
  },
  {
    id: 133,
    name: "Cold Chain Storage",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Temperature-controlled storage and transport",
    effectiveDate: "11/01/2025",
    expirationDate: "11/01/2026",
    version: 2,
    status: "Active",
    createdDate: "10/01/2025",
    createdBy: "Patricia Garcia",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 134,
    name: "White Glove Service",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Premium white glove delivery service",
    effectiveDate: "12/01/2025",
    expirationDate: "12/01/2026",
    version: 1,
    status: "Draft",
    createdDate: "11/15/2025",
    createdBy: "Quinn Rodriguez",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 135,
    name: "Oversize Freight",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Special handling for oversized freight items",
    effectiveDate: "05/01/2025",
    expirationDate: "05/01/2026",
    version: 7,
    status: "Inactive",
    createdDate: "04/01/2025",
    createdBy: "Rachel Wilson",
    modifiedDate: "04/20/2025",
    modifiedBy: "Sam Moore",
  },
  {
    id: 136,
    name: "Limited Access",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Additional fee for limited access locations",
    effectiveDate: "09/15/2025",
    expirationDate: "09/15/2026",
    version: 4,
    status: "Active",
    createdDate: "08/20/2025",
    createdBy: "Tom Taylor",
    modifiedDate: "09/01/2025",
    modifiedBy: "Uma Anderson",
  },
  {
    id: 137,
    name: "Assembly Required",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Charge for on-site assembly services",
    effectiveDate: "10/01/2025",
    expirationDate: "10/01/2026",
    version: 3,
    status: "Active",
    createdDate: "09/10/2025",
    createdBy: "Victor Harris",
    modifiedDate: "09/25/2025",
    modifiedBy: "Wendy Clark",
  },
  {
    id: 138,
    name: "Documentation Fee",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Custom documentation and paperwork handling",
    effectiveDate: "11/10/2025",
    expirationDate: "11/10/2026",
    version: 2,
    status: "Draft",
    createdDate: "10/25/2025",
    createdBy: "Xavier Lewis",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 139,
    name: "Redelivery Charge",
    ruleType: "ITEM_1400",
    ruleTypeDisplay:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Charge for failed delivery reattempts",
    effectiveDate: "08/15/2025",
    expirationDate: "08/15/2026",
    version: 5,
    status: "Active",
    createdDate: "07/20/2025",
    createdBy: "Yolanda Walker",
    modifiedDate: "08/01/2025",
    modifiedBy: "Zach Hall",
  },
  {
    id: 140,
    name: "Appointment Delivery",
    ruleType: "ITEM_1400",
    ruleTypeDisplay:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Fee for scheduled appointment deliveries",
    effectiveDate: "07/15/2025",
    expirationDate: "07/15/2026",
    version: 6,
    status: "Active",
    createdDate: "06/25/2025",
    createdBy: "Amy Allen",
    modifiedDate: "07/05/2025",
    modifiedBy: "Ben Young",
  },
  {
    id: 141,
    name: "Notification Service",
    ruleType: "ITEM_1400",
    ruleTypeDisplay:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Advanced delivery notification service",
    effectiveDate: "09/20/2025",
    expirationDate: "09/20/2026",
    version: 1,
    status: "Inactive",
    createdDate: "09/01/2025",
    createdBy: "Cathy King",
    modifiedDate: "09/10/2025",
    modifiedBy: "Dan Wright",
  },
  {
    id: 142,
    name: "Storage in Transit",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Storage in transit charges per day",
    effectiveDate: "06/15/2025",
    expirationDate: "06/15/2026",
    version: 9,
    status: "Active",
    createdDate: "05/20/2025",
    createdBy: "Elena Scott",
    modifiedDate: "06/01/2025",
    modifiedBy: "Fred Adams",
  },
  {
    id: 143,
    name: "Protection Plan",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Extended cargo protection plan",
    effectiveDate: "10/20/2025",
    expirationDate: "10/20/2026",
    version: 3,
    status: "Draft",
    createdDate: "10/05/2025",
    createdBy: "Gina Baker",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 144,
    name: "Cross-Dock Service",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Cross-dock facility handling charges",
    effectiveDate: "08/20/2025",
    expirationDate: "08/20/2026",
    version: 4,
    status: "Active",
    createdDate: "07/25/2025",
    createdBy: "Hugo Nelson",
    modifiedDate: "08/10/2025",
    modifiedBy: "Iris Carter",
  },
  {
    id: 145,
    name: "Sort and Segregate",
    ruleType: "ITEM_1360",
    ruleTypeDisplay: "ITEM_1360 - Minimum Charge Cubic Capacity and Density",
    description: "Sorting and segregation service charges",
    effectiveDate: "11/25/2025",
    expirationDate: "11/25/2026",
    version: 2,
    status: "Active",
    createdDate: "11/10/2025",
    createdBy: "Jake Mitchell",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 146,
    name: "Palletizing Service",
    ruleType: "ITEM_1400",
    ruleTypeDisplay:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Palletizing and wrapping service",
    effectiveDate: "07/20/2025",
    expirationDate: "07/20/2026",
    version: 5,
    status: "Inactive",
    createdDate: "06/30/2025",
    createdBy: "Kelly Perez",
    modifiedDate: "07/10/2025",
    modifiedBy: "Leo Roberts",
  },
  {
    id: 147,
    name: "Marking and Tagging",
    ruleType: "ITEM_1400",
    ruleTypeDisplay:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Custom marking and tagging services",
    effectiveDate: "12/05/2025",
    expirationDate: "12/05/2026",
    version: 1,
    status: "Draft",
    createdDate: "11/20/2025",
    createdBy: "Maria Turner",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 148,
    name: "Reconsignment Fee",
    ruleType: "ITEM_1400",
    ruleTypeDisplay:
      "ITEM_1400 - Residential Delivery - Auto Application of Liftgate Rule",
    description: "Fee for address changes after shipment",
    effectiveDate: "09/25/2025",
    expirationDate: "09/25/2026",
    version: 7,
    status: "Active",
    createdDate: "09/05/2025",
    createdBy: "Nathan Phillips",
    modifiedDate: "09/15/2025",
    modifiedBy: "Olivia Campbell",
  },
];
